import { RouterModule, Routes } from '@angular/router';
import { ActualStepRedirectComponent } from '@app/modules/actual-step-redirect/actual-step-redirect.component';
import { LoginGuard } from '@app/guards/login.guard';
import { BankIdGuard } from '@app/guards/bankid.guard';
import { BankIdPageComponent } from '@app/modules/page/bankid-page/bankid-page.component';
import { LoginComponent } from '@app/modules/login/login.component';
import { IsLoggedGuard } from '@app/guards/is-logged.guard';
import { LogoutFirstGuard } from '@app/guards/logout-first.guard';
import { MortgageResolver } from '@app/resolvers/mortgage.resolver';

export const appRoutes: Routes = [
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [IsLoggedGuard],
    },
    {
        path: 'reverification/:code',
        component: LoginComponent,
        canActivate: [LogoutFirstGuard],
    },
    {
        path: 'actual/:mortgageId',
        canActivate: [LoginGuard],
        resolve: {
            mortgage: MortgageResolver,
        },
        component: ActualStepRedirectComponent,
    },
    {
        path: 'bankid',
        canActivate: [LoginGuard, BankIdGuard],
        component: BankIdPageComponent,
    },
    {
        path: 'camera-upload',
        loadChildren: () =>
            import('@app/modules/mobile/page/camera-upload/camera-upload.module').then((m) => m.CameraUploadModule),
        resolve: {
            mortgage: MortgageResolver,
        },
    },
    {
        path: 'mobile',
        resolve: {
            mortgage: MortgageResolver,
        },
        loadChildren: () =>
            import('@app/layout/mobile/layout-mobile/layout-mobile.module').then((m) => m.LayoutMobileModule),
    },
    {
        path: '',
        resolve: {
            mortgage: MortgageResolver,
        },
        loadChildren: () =>
            import('@app/layout/desktop/layout-desktop/layout-desktop.module').then((m) => m.LayoutDesktopModule),
    },
    {
        path: '**',
        redirectTo: '/login',
        pathMatch: 'full',
    },
];

export const AppRouter = RouterModule.forRoot(appRoutes, {});
